
        (function () {
          function initImagineHelp() {
            var root = document.getElementById('ifhRoot');
            if (!root || root.dataset.initialized === 'true') return;
            root.dataset.initialized = 'true';

            var launcher = document.getElementById('ifhLauncher');
            var launcherLabel = document.getElementById('ifhLauncherLabel');
            var popover = document.getElementById('ifhPopover');
            var stage = document.getElementById('ifhStage');
            var mainView = root.querySelector('[data-ifh-view="main"]');
            var faqView = root.querySelector('[data-ifh-view="faq"]');
            var faqOpen = document.getElementById('ifhFaqOpen');
            var faqBack = document.getElementById('ifhFaqBack');
            var faqClose = document.getElementById('ifhFaqClose');
            var callToggle = document.getElementById('ifhCallToggle');
            var callReveal = document.getElementById('ifhCallReveal');
            var callLabel = document.getElementById('ifhCallLabel');
            var status = document.getElementById('ifhStatus');
            var statusText = document.getElementById('ifhStatusText');
            var phoneNote = document.getElementById('ifhPhoneNote');
            var activeView = 'main';
            var resizeTimer = null;

            if (!launcher || !popover || !stage || !mainView || !faqView) return;

            function setStageHeight(animate) {
              var view = activeView === 'faq' ? faqView : mainView;
              if (!view) return;

              if (animate === false) {
                var oldTransition = stage.style.transition;
                stage.style.transition = 'none';
                stage.style.height = view.scrollHeight + 'px';
                stage.offsetHeight;
                stage.style.transition = oldTransition;
              } else {
                stage.style.height = view.scrollHeight + 'px';
              }
            }

            function setView(name) {
              activeView = name === 'faq' ? 'faq' : 'main';
              var showFaq = activeView === 'faq';

              mainView.classList.toggle('is-active', !showFaq);
              faqView.classList.toggle('is-active', showFaq);
              mainView.setAttribute('aria-hidden', showFaq ? 'true' : 'false');
              faqView.setAttribute('aria-hidden', showFaq ? 'false' : 'true');

              requestAnimationFrame(function () {
                setStageHeight(true);
              });
            }

            function openWidget() {
              root.classList.add('is-open');
              popover.removeAttribute('inert');
              launcher.setAttribute('aria-expanded', 'true');
              popover.setAttribute('aria-hidden', 'false');
              launcherLabel.textContent = 'Close';

              requestAnimationFrame(function () {
                setStageHeight(false);
              });
            }

            function closeWidget() {
              root.classList.remove('is-open');
              popover.setAttribute('inert', '');
              launcher.setAttribute('aria-expanded', 'false');
              popover.setAttribute('aria-hidden', 'true');
              launcherLabel.textContent = 'Help';
            }

            function resetFaqItems() {
              root.querySelectorAll('.ifh-faq-item').forEach(function (item) {
                item.classList.remove('is-open');
                var button = item.querySelector('.ifh-faq-question');
                if (button) button.setAttribute('aria-expanded', 'false');
              });
            }

            function dateKey(year, month, day) {
              return [String(year), String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
            }

            function keyFromUtcDate(date) {
              return dateKey(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
            }

            function addDaysUtc(date, days) {
              var copy = new Date(date.getTime());
              copy.setUTCDate(copy.getUTCDate() + days);
              return copy;
            }

            function firstMondayOfMonth(year, monthIndex) {
              var date = new Date(Date.UTC(year, monthIndex, 1));
              var offset = (8 - date.getUTCDay()) % 7;
              return addDaysUtc(date, offset);
            }

            /*
      Gregorian Easter calculation (Meeus/Jones/Butcher).
      Used so Good Friday and Easter Monday continue to work automatically
      each year without maintaining a manual holiday list.
    */
            function getEasterSundayUtc(year) {
              var a = year % 19;
              var b = Math.floor(year / 100);
              var c = year % 100;
              var d = Math.floor(b / 4);
              var e = b % 4;
              var f = Math.floor((b + 8) / 25);
              var g = Math.floor((b - f + 1) / 3);
              var h = (19 * a + b - d - g + 15) % 30;
              var i = Math.floor(c / 4);
              var k = c % 4;
              var l = (32 + 2 * e + 2 * i - h - k) % 7;
              var m = Math.floor((a + 11 * h + 22 * l) / 451);
              var month = Math.floor((h + l - 7 * m + 114) / 31);
              var day = ((h + l - 7 * m + 114) % 31) + 1;
              return new Date(Date.UTC(year, month - 1, day));
            }

            function getGoldCoastPublicHolidays(year) {
              var holidays = {};

              function add(date, name) {
                holidays[keyFromUtcDate(date)] = name;
              }

              function addYmd(monthIndex, day, name) {
                add(new Date(Date.UTC(year, monthIndex, day)), name);
              }

              /* New Year's Day + additional weekday when it falls on a weekend. */
              var newYearsDay = new Date(Date.UTC(year, 0, 1));
              add(newYearsDay, "New Year's Day");
              if (newYearsDay.getUTCDay() === 6) {
                add(new Date(Date.UTC(year, 0, 3)), "New Year's Day public holiday");
              } else if (newYearsDay.getUTCDay() === 0) {
                add(new Date(Date.UTC(year, 0, 2)), "New Year's Day public holiday");
              }

              /* Australia Day is observed on the following Monday if 26 January is a weekend. */
              var australiaDay = new Date(Date.UTC(year, 0, 26));
              add(australiaDay, 'Australia Day');
              if (australiaDay.getUTCDay() === 6) {
                add(new Date(Date.UTC(year, 0, 28)), 'Australia Day public holiday');
              } else if (australiaDay.getUTCDay() === 0) {
                add(new Date(Date.UTC(year, 0, 27)), 'Australia Day public holiday');
              }

              /* Easter public holidays. */
              var easterSunday = getEasterSundayUtc(year);
              add(addDaysUtc(easterSunday, -2), 'Good Friday');
              add(addDaysUtc(easterSunday, -1), 'Easter Saturday');
              add(easterSunday, 'Easter Sunday');
              add(addDaysUtc(easterSunday, 1), 'Easter Monday');

              /* Anzac Day: Queensland substitutes Monday only when 25 April is a Sunday. */
              var anzacDay = new Date(Date.UTC(year, 3, 25));
              add(anzacDay, 'Anzac Day');
              if (anzacDay.getUTCDay() === 0) {
                add(new Date(Date.UTC(year, 3, 26)), 'Anzac Day public holiday');
              }

              /* Queensland Labour Day and King's Birthday. */
              add(firstMondayOfMonth(year, 4), 'Labour Day');
              add(firstMondayOfMonth(year, 9), "King's Birthday");

              /* Christmas Day and Boxing Day + additional weekday holidays when required. */
              var christmasDay = new Date(Date.UTC(year, 11, 25));
              var boxingDay = new Date(Date.UTC(year, 11, 26));
              add(christmasDay, 'Christmas Day');
              add(boxingDay, 'Boxing Day');

              if (christmasDay.getUTCDay() === 6 || christmasDay.getUTCDay() === 0) {
                add(new Date(Date.UTC(year, 11, 27)), 'Christmas Day public holiday');
              }

              if (boxingDay.getUTCDay() === 6 || boxingDay.getUTCDay() === 0) {
                add(new Date(Date.UTC(year, 11, 28)), 'Boxing Day public holiday');
              }

              /*
        Gold Coast Show Day is a LOCAL public holiday and is appointed each year.
        These dates are the officially gazetted City of Gold Coast dates currently
        available from the Queensland Government.

        Add the next year's gazetted date here once Queensland publishes it.
      */
              var goldCoastShowDays = {
                2021: '2021-08-27',
                2022: '2022-08-26',
                2023: '2023-09-01',
                2024: '2024-08-30',
                2025: '2025-08-29',
                2026: '2026-08-28',
              };

              if (goldCoastShowDays[year]) {
                holidays[goldCoastShowDays[year]] = 'Gold Coast Show public holiday';
              }

              return holidays;
            }

            function updatePhoneStatus() {
              if (!status || !statusText) return;

              try {
                var formatter = new Intl.DateTimeFormat('en-AU', {
                  timeZone: 'Australia/Brisbane',
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  weekday: 'short',
                  hour: '2-digit',
                  minute: '2-digit',
                  hourCycle: 'h23',
                });

                var parts = formatter.formatToParts(new Date());
                var values = {};

                parts.forEach(function (part) {
                  values[part.type] = part.value;
                });

                var year = parseInt(values.year || '0', 10);
                var month = parseInt(values.month || '0', 10);
                var day = parseInt(values.day || '0', 10);
                var weekday = values.weekday || '';
                var hour = parseInt(values.hour || '0', 10);
                var minute = parseInt(values.minute || '0', 10);
                var minutesNow = hour * 60 + minute;
                var todayKey = dateKey(year, month, day);
                var holidays = getGoldCoastPublicHolidays(year);
                var holidayName = holidays[todayKey] || '';

                /* Christmas Eve is a Queensland part-day public holiday from 6pm. */
                if (!holidayName && month === 12 && day === 24 && minutesNow >= 1080) {
                  holidayName = 'Christmas Eve public holiday';
                }

                var weekdayOpen = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(weekday) !== -1;
                var timeOpen = minutesNow >= 540 && minutesNow < 1020;
                var isPublicHoliday = holidayName !== '';
                var isOpen = weekdayOpen && timeOpen && !isPublicHoliday;

                status.classList.toggle('is-open', isOpen);
                status.classList.toggle('is-closed', !isOpen);

                if (isPublicHoliday) {
                  statusText.textContent = 'Phone support is closed today · ' + holidayName;
                  if (phoneNote) {
                    phoneNote.textContent =
                      'Our phones are offline today for the ' +
                      holidayName +
                      '. Phone support will reopen on the next business day from 9:00am AEST.';
                  }
                } else if (isOpen) {
                  statusText.textContent = 'Phone support is open now · 9:00am–5:00pm AEST';
                  if (phoneNote) {
                    phoneNote.textContent =
                      'Phone support is available Monday to Friday, 9:00am to 5:00pm AEST, excluding public holidays.';
                  }
                } else {
                  statusText.textContent = 'Phone support is currently closed · Mon–Fri, 9:00am–5:00pm AEST';
                  if (phoneNote) {
                    phoneNote.textContent =
                      'Phone support is available Monday to Friday, 9:00am to 5:00pm AEST, excluding public holidays.';
                  }
                }
              } catch (error) {
                statusText.textContent = 'Phone support: Monday to Friday, 9:00am–5:00pm AEST';
                if (phoneNote) {
                  phoneNote.textContent =
                    'Phone support is available Monday to Friday, 9:00am to 5:00pm AEST, excluding public holidays.';
                }
              }
            }

            launcher.addEventListener('click', function () {
              if (root.classList.contains('is-open')) {
                closeWidget();
              } else {
                openWidget();
              }
            });

            if (faqOpen) {
              faqOpen.addEventListener('click', function () {
                setView('faq');
                setTimeout(function () {
                  if (faqBack) faqBack.focus({ preventScroll: true });
                }, 220);
              });
            }

            if (faqBack) {
              faqBack.addEventListener('click', function () {
                setView('main');
                setTimeout(function () {
                  if (faqOpen) faqOpen.focus({ preventScroll: true });
                }, 220);
              });
            }

            if (faqClose) {
              faqClose.addEventListener('click', function () {
                closeWidget();
                setTimeout(function () {
                  launcher.focus({ preventScroll: true });
                }, 120);
              });
            }

            if (callToggle && callReveal) {
              callToggle.addEventListener('click', function () {
                var opening = !callReveal.classList.contains('is-open');
                callReveal.classList.toggle('is-open', opening);
                callToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
                if (callLabel) callLabel.textContent = opening ? 'Hide phone numbers' : 'Call us';

                requestAnimationFrame(function () {
                  setStageHeight(true);
                });
              });
            }

            root.querySelectorAll('.ifh-faq-question').forEach(function (question) {
              question.addEventListener('click', function () {
                var item = question.closest('.ifh-faq-item');
                if (!item) return;

                var opening = !item.classList.contains('is-open');

                root.querySelectorAll('.ifh-faq-item').forEach(function (otherItem) {
                  var otherButton = otherItem.querySelector('.ifh-faq-question');
                  if (otherItem !== item) {
                    otherItem.classList.remove('is-open');
                    if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
                  }
                });

                item.classList.toggle('is-open', opening);
                question.setAttribute('aria-expanded', opening ? 'true' : 'false');

                requestAnimationFrame(function () {
                  setStageHeight(true);
                });

                setTimeout(function () {
                  setStageHeight(true);
                }, 320);
              });
            });

            document.addEventListener('click', function (event) {
              if (!root.classList.contains('is-open')) return;
              if (!root.contains(event.target)) {
                closeWidget();
              }
            });

            document.addEventListener('keydown', function (event) {
              if (event.key === 'Escape' && root.classList.contains('is-open')) {
                closeWidget();
                launcher.focus({ preventScroll: true });
              }
            });

            window.addEventListener('resize', function () {
              window.clearTimeout(resizeTimer);
              resizeTimer = window.setTimeout(function () {
                if (root.classList.contains('is-open')) {
                  setStageHeight(false);
                }
              }, 100);
            });

            updatePhoneStatus();
            setInterval(updatePhoneStatus, 60000);
            setView('main');
            setStageHeight(false);

            window.addEventListener('pageshow', function () {
              if (root.classList.contains('is-open')) {
                requestAnimationFrame(function () {
                  setStageHeight(false);
                });
              }
            });
          }

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initImagineHelp, { once: true });
          } else {
            initImagineHelp();
          }
        })();
      